<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="container">
    <div class="row qa-part">
      <div class="col-md-12 subtitle-container">
        <h1>សំនួរចំលើយសំរាប់អ្នកខ្ចីប្រាក់</h1>
      </div>
      <div
        class="col-md-12"
        style="margin-left: 15px;"
      >
        <collapsible-q-a>
          <template v-slot:question>
            <strong>1. តើត្រូវការរយៈពេលប៉ុន្មានដើម្បីទទួលបានការយល់ព្រម?</strong>
          </template>
          <template v-slot:answer>
            <label>ជាទូទៅពី ១២ ទៅ ២៤ ម៉ោង។</label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>2. តើលក្ខខណ្ឌនៃប្រាក់កម្ចីមានលក្ខខណ្ឌអ្វីខ្លះ?</strong>
          </template>
          <template v-slot:answer>
            <label>
              ដើម្បីទទួលបានប្រាក់កម្ចីសូមដាក់ពាក្យសុំតាមអ៊ីនធឺណិត
              <router-link :to="{name: 'borrow-form', params: {formType: 'borrow'}}">(ភ្ជាប់នៅទីនេះ)</router-link>
              ។ យើងផ្តល់ប្រាក់កម្ចីដល់ពលរដ្ឋកម្ពុជាណាម្នាក់ដែលមានអាយុចាប់ពី ១៨-៥០ ឆ្នាំ
              អាចផ្តល់ភស្តុតាងនៃប្រាក់ចំណូលប្រចាំខែ ដែលរស់នៅក្នុងរាជធានីភ្នំពេញ ខេត្តសៀមរាប និងក្រុងព្រះសីហនុ។
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>3. តើត្រូវការព័ត៌មានអ្វីខ្លះដើម្បីអនុវត្ត?</strong>
          </template>
          <template v-slot:answer>
            <label>
              អ្នកត្រូវបំពេញពាក្យសុំ
              <router-link :to="{name: 'borrow-form', params: {formType: 'borrow'}}">(ភ្ជាប់នៅទីនេះ)</router-link>
              និង <strong>ផ្តល់ព័ត៌មានផ្ទាល់ខ្លួន</strong>, <strong>ព័ត៌មានការងារ</strong>, និង
              <strong>ព័ត៌មានសាច់ញាតិ</strong>.
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>4. តើអ្វីជាភាពខុសគ្នារវាងប្រាក់ប្រចាំថ្ងៃនិងប្រាក់កម្ចីផ្ទាល់ខ្លួន?</strong>
          </template>
          <template v-slot:answer>
            <label>
              ប្រាក់កម្ចីថ្ងៃបើកប្រាក់បៀវត្សមានរយៈពេលប្រាក់កម្ចីខ្លីជាងធម្មតាដែលមានរយៈពេលពី ១០ ទៅ ៣០
              ថ្ងៃហើយទូទាត់សងវិញតែម្តង។ ប្រាក់កម្ចីផ្ទាល់ខ្លួនមានរយៈពេលខ្ចីវែងជាធម្មតាពី ១ ទៅ ៦ ខែហើយអាចសងរាល់ខែ។
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>5. តើខ្ញុំអាចខ្ចីបានប៉ុន្មាន?</strong>
          </template>
          <template v-slot:answer>
            <label>គ្មានចម្លើយ</label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>6. ខ្ញុំកំពុងបើកអាជីវកម្មតើខ្ញុំអាចស្នើសុំប្រាក់កម្ចីបានទេ?</strong>
          </template>
          <template v-slot:answer>
            <label>
              បាន, យើងត្រូវការប្រវត្តិប្រាក់ចំណូលឬវត្ថុបញ្ចាំ។
              យើងក៏នឹងត្រូវយល់អំពីមូលហេតុនៃប្រាក់កម្ចីនិងអាជីវកម្មដែលអ្នកកំពុងប្រតិបត្តិការ។
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>7. តើមានប្រាក់កំចីសំរាប់និស្សិតទេ?</strong>
          </template>
          <template v-slot:answer>
            <label>
              បាន, ប្រសិនបើអ្នករកបានប្រាក់ចំណូលប្រចាំខែ ២០០ ដុល្លារនិងមានអត្តសញ្ញាណប័ណ្ណនិស្សិតសាកលវិទ្យាល័យ។
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>8. តើមានអត្រាអនុគ្រោះសម្រាប់និស្សិតដែរឬទេ?</strong>
          </template>
          <template v-slot:answer>
            <label>
              ត្រូវហើយ Cash Hero ផ្តល់អត្រាការប្រាក់ពិសេសដល់និស្សិត។
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>9. ខ្ញុំមកពីខេត្តមួយដែលមិនមានទាំងសៀមរាប ភ្នំពេញ និងខេត្តព្រះសីហនុ
              តើខ្ញុំអាចស្នើសុំប្រាក់កម្ចីបានទេ?</strong>
          </template>
          <template v-slot:answer>
            <label>បាន, អត្រាអនុម័តទាបជាង។</label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>10. តើអ្នកគិតថ្លៃយ៉ាងដូចម្តេច?</strong>
          </template>
          <template v-slot:answer>
            <label>
              យើងនឹងគិតថ្លៃ <strong>អត្រាការប្រាក់</strong>, <strong>ថ្លៃសេវាប្រឹក្សា</strong>, និង<strong>ថ្លៃដំណើរការ</strong>។
              សូមពិនិត្យមើលចំនួនទឹកប្រាក់ដែលបានគណនានៅលើគេហទំព័ររបស់យើង។<a href="/">(ភ្ជាប់ទៅទំព័រមុខនៅទីនេះ)</a>
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>11. តើខ្ញុំត្រូវការឯកសារយោងសម្រាប់ប្រាក់កម្ចីទេ?</strong>
          </template>
          <template v-slot:answer>
            <label>ត្រូវហើយ, ឯកសារយោងរបស់អ្នកនឹងជួយយើងកំណត់ភាពជឿជាក់របស់អ្នក។</label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>12. តើ Cash Hero ស្ថិតនៅទីណា?</strong>
          </template>
          <template v-slot:answer>
            <label>យើងមានទីតាំងនៅ: #3, ផ្លូវ 317, សង្កាត់បឹងកក់ 1, ខណ្ឌទួលគោក, រាជធានីភ្នំពេញ, ប្រទេសកម្ពុជា។
              សូមទំនាក់ទំនងមកយើងខ្ញុំតាម <a
                href="mailto:info@cashherokh.com"
                target="_blank"
              >cashhero@gmail com</a>,
              Tel: <span class="label-color-blue">070360289</span> ឬផ្ញើសារជាមួយយើងនៅលើគេហទំព័ររបស់យើង។</label>
          </template>
        </collapsible-q-a>
      </div>
    </div>
    <div class="row qa-part">
      <div class="col-md-12 subtitle-container">
        <h1>សំណួរសម្រាប់វិនិយោគិន</h1>
      </div>
      <div
        class="col-md-12"
        style="margin-left: 15px;"
      >
        <collapsible-q-a>
          <template v-slot:question>
            <strong>1. តើខ្ញុំវិនិយោគជាមួយ Cash Hero យ៉ាងដូចម្តេច?</strong>
          </template>
          <template v-slot:answer>
            <label>សូមបញ្ជូនព័ត៌មានរបស់អ្នកតាមរយៈពាក្យសុំរបស់វិនិយោគិន។ <router-link
              :to="{path: 'invest-form'}"
            >(ភ្ជាប់នៅទីនេះ)</router-link></label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>2. តើចំនួនទឹកប្រាក់វិនិយោគអប្បបរមាមានចំនួនប៉ុន្មាន?</strong>
          </template>
          <template v-slot:answer>
            <label>
              ការវិនិយោគអប្បបរមាគឺពី ៥០០០ ដុល្លារទៅ ១៥០០០ ដុល្លារ។
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>3. តើការវិនិយោគត្រឡប់មកវិញមានប៉ុន្មាន?</strong>
          </template>
          <template v-slot:answer>
            <label>
              សូមមើលតារាងនៅទំព័រវិនិយោគរបស់យើង
            </label>
            <div class="row">
              <div class="col-md-6">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>ចំនួនទឹកប្រាក់វិនិយោគ</th>
                      <th>អត្រាត្រឡប់ប្រចាំឆ្នាំ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>$5k to $15k</td>
                      <td>10%</td>
                    </tr>
                    <tr>
                      <td>$15k to $25k</td>
                      <td>11%</td>
                    </tr>
                    <tr>
                      <td>$25k to $50k</td>
                      <td>12%</td>
                    </tr>
                    <tr>
                      <td>$50K <sup>+</sup></td>
                      <td>សូមពិភាក្សា</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>4. តើរយៈពេលវិនិយោគអប្បបរមាមានរយៈពេលប៉ុន្មាន?</strong>
          </template>
          <template v-slot:answer>
            <label>មួយឆ្នាំឬ ១២ ខែ</label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>5. តើពេលណាការត្រឡប់មកវិញរបស់ខ្ញុំលើការវិនិយោគត្រូវបានគណនា?</strong>
          </template>
          <template v-slot:answer>
            <label>
              ចំណូលពីការវិនិយោគត្រូវបានគណនានិងធ្វើបច្ចុប្បន្នភាពប្រចាំត្រីមាស។
              អ្នកអាចស្នើសុំឱ្យអ្នកផ្តល់មូលនិធិត្រឡប់មកវិញបន្ទាប់ពីធ្វើជាវិនិយោគិនអស់រយៈពេលមួយឆ្នាំ។
            </label>
          </template>
        </collapsible-q-a>

        <collapsible-q-a>
          <template v-slot:question>
            <strong>6. តើខ្ញុំស្នើសុំមូលនិធិរបស់ខ្ញុំយ៉ាងដូចម្តេច?</strong>
          </template>
          <template v-slot:answer>
            <label>
              យើងនឹងផ្តល់លេខទូរស័ព្ទវីអាយភីដល់វិនិយោគិនដែលបានជ្រើសរើស។
              អ្នកនឹងអាចទៅដល់យើងគ្រប់ពេលដើម្បីដាក់ប្រាក់ឬដកប្រាក់។
              សូមកត់សម្គាល់ថាការផ្ទេរចំនួនទឹកប្រាក់នឹងមិនរាប់បញ្ចូលថ្លៃសេវាសក្តានុពលដូចជាថ្លៃសេវាធនាគារថ្លៃសេវាផ្ទេរថ្លៃសេវាប្តូរប្រាក់បរទេសឬពន្ធ។
            </label>
          </template>
        </collapsible-q-a>
      </div>
    </div>
  </div>
</template>

<script>
import CollapsibleQA from './../../CollapsibleQA'

export default {
  name: 'FaqKhmer',
  components: { CollapsibleQA }
}
</script>

<style scoped>

</style>
